/**
 * Lane STUDIO-BOTDUEL: a bout seat lent to the stand-in's extra minds (systems/duelBotSlide.ts, duelBotLock.ts). Those read
 * the bout as "the bot is `foeId`, its foe `meId`, not between two players"; while `systems/botBout.ts` runs them for one
 * seat of a bot-vs-bot bout, `botSeatOf` hands them that seat's view instead of the bout's own. Empty otherwise, so the
 * game's bout vs the stand-in reads exactly as before.
 */
import type { MatchState } from './duelMatch';

const SEATS = new WeakMap<object, Readonly<MatchState>>();

/** The seat being driven in World `w` right now, else null (the bout's own state applies). */
export const botSeatOf = (w: object): Readonly<MatchState> | null => SEATS.get(w) ?? null;

/** Runs `f` with `view` as World `w`'s bout seat. */
export function asBotSeat(w: object, view: Readonly<MatchState>, f: () => void): void {
  SEATS.set(w, view);
  try {
    f();
  } finally {
    SEATS.delete(w);
  }
}
